import React from "react";
import styles from "./LoadingSpinner.module.scss";

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = "Loading..." 
}) => {
  return (
    <div className={styles.loadingSection}>
      <div className={styles.loadingContent}>
        <div className={styles.spinner}>
          <div className={styles.chase}>
            <div className={styles.chaseDot}></div>
            <div className={styles.chaseDot}></div>
            <div className={styles.chaseDot}></div>
            <div className={styles.chaseDot}></div>
            <div className={styles.chaseDot}></div>
            <div className={styles.chaseDot}></div>
          </div>
        </div>
        <p className={styles.loadingMessage}>{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;